import { Panel, PanelBorderRadius, PanelBorderStyle, PanelTheme } from '@apply/components';
import { isMobileScreen } from '@apply/ui';

export const ContingencyNotificationMessage: React.FC = () => {
    const mobileScreen = isMobileScreen();
    return (
        <>
            <Panel
                theme={PanelTheme.Yellow}
                borderRadius={PanelBorderRadius.Small}
                borderStyle={PanelBorderStyle.None}
                width={mobileScreen ? '88%' : '370px'}
            >
                Level eligibility contingent on BFI Review of Experience.
            </Panel>
        </>
    );
};
